import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/LnQdhedsilB1iPrahkmD/locations/aECtAWd3m4Q4QqzDlwRT`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="80%"
                  minWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/LnQdhedsilB1iPrahkmD/locations/aECtAWd3m4Q4QqzDlwRT`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="340px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
